import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Уведомление о куки",
    description:
      "Мы используем необходимые куки для корректной работы этого сайта. Мы также используем дополнительные куки для отслеживания, чтобы понять, как вы взаимодействуете с нашим сайтом. Эти дополнительные куки будут установлены только с вашего согласия.",
    acceptAllBtn: "Принять все",
    acceptNecessaryBtn: "Отклонить все",
    showPreferencesBtn: "Управлять индивидуальными предпочтениями",
  },
  preferencesModal: {
    title: "Управление настройками куки",
    acceptAllBtn: "Принять все",
    acceptNecessaryBtn: "Отклонить все",
    savePreferencesBtn: "Принять текущий выбор",
    closeIconLabel: "Закрыть окно",
    sections: [
      {
        title: "Использование куки",
        description:
          "Мы используем куки, чтобы поддерживать основные функции этого сайта и улучшить ваш опыт использования.",
      },
      {
        title: "Строго необходимые куки",
        description: "Эти куки необходимы для правильной работы сайта, например для аутентификации пользователя.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: { name: "Название", domain: "Сервис", description: "Описание", expiration: "Срок действия" },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "Куки, установленная цифровой платформой сообщества для аутентификации пользователя.",
              expiration: "Сессия",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "Куки, установленная цифровой платформой сообщества для аутентификации пользователя.",
              expiration: "Сессия",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Эта куки используется для различения людей и роботов, чтобы защитить сайт от автоматизированного злоупотребления. Персональные данные не собираются.",
              expiration: "30 минут",
            },
          ],
        },
      },
      {
        title: "Аналитика",
        description:
          "Куки, используемые для аналитики, помогают собирать данные, которые позволяют сервисам понимать, как пользователи взаимодействуют с конкретным сервисом. Эти данные позволяют улучшать контент и создавать более полезные функции для повышения качества пользовательского опыта.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: { name: "Название", domain: "Сервис", description: "Описание", expiration: "Срок действия" },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Куки, установленная <a href="https://business.safety.google/adscookies/">Google Analytics</a>.',
              expiration: "Истекает через 12 дней",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Куки, установленная <a href="https://business.safety.google/adscookies/">Google Analytics</a>.',
              expiration: "Сессия",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "Включает хранение, связанное с аналитикой, например, продолжительность визита.";

export { translation, servicesLabel };
